var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeafIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.17275 12.4675C3.55475 12.4675 2.28461 11.9979 2.23311 11.9802L2.07682 11.9279L2.02449 11.7716C1.97217 11.5976 0.615108 7.35327 2.89431 4.62134C5.93868 1.00272 10.9659 0.898865 11.5233 0.898865H11.8889L11.9235 1.21214C11.9412 1.45541 12.4977 7.4056 9.90519 10.45C8.77375 11.7717 7.13882 12.4676 5.17286 12.4676L5.17275 12.4675ZM2.63253 11.3713C3.01512 11.493 4.00657 11.7539 5.17275 11.7539C6.94701 11.7539 8.35646 11.1627 9.36563 9.97967C11.4354 7.54418 11.3138 2.8649 11.2446 1.59479C10.0092 1.64712 5.95646 2.04738 3.43399 5.07407C1.62372 7.214 2.40652 10.5885 2.6328 11.3714L2.63253 11.3713Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.354125 12.7977C0.214818 12.7977 0.0755045 12.7107 0.0238721 12.5714C-0.045442 12.3974 0.04154 12.1888 0.215511 12.1188C0.233178 12.1011 2.45929 11.1966 4.12969 9.77026C5.67769 8.43088 7.2433 5.87382 7.26104 5.85608C7.36569 5.68212 7.57432 5.62979 7.74828 5.73444C7.92224 5.83909 7.97457 6.04771 7.86992 6.22168C7.80061 6.32633 6.23494 8.90037 4.59923 10.3098C2.84184 11.8232 0.59806 12.7276 0.493334 12.7631C0.441009 12.7977 0.388685 12.7977 0.354028 12.7977L0.354125 12.7977Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeafIcon);
export default __webpack_public_path__ + "static/media/leaf-icon.e8709d12ca3a83aa5b830e8c52ddc0f8.svg";
export { ForwardRef as ReactComponent };